module.exports = __webpack_public_path__ + "static/media/resources.fb49d325.svg";